import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		min-height: calc(100vh - 90px);
		flex: 1 1 auto;
		padding: 0 2em;
		background-color: var(--primary-color);

		display: flex;
		flex-direction: column;

		h2 {
			color: var(--white);
		}

		.cupons {
			padding: 0;
			display: flex;
			flex-direction: column;
			row-gap: 1em;
			margin-top: 0;

			li {
				background-color: var(--white);
				padding: 1em;
				border-radius: 8px;
				display: flex;
				flex-direction: column;
				box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1);
				margin: 5px 0;

				p {
					margin: 2px 0;
				}

				header {
					display: flex;
					justify-content: space-between;
				}

				.cupomInfo {
					display: flex;
					justify-content: space-between;
					align-items: flex-end;

					.animal {
						.name {
							text-transform: capitalize;
						}
					}

					.action {
						display: flex;

						img {
							cursor: pointer;

							& + img {
								margin-left: 1em;
							}
						}
					}
				}
			}
		}

		.modal {
			background-color: var(--white);

			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			padding: 2em 1em;
			z-index: 2000;

			.content {
				height: 100%;
				max-width: 567px;
				max-height: 567px;
				background-color: var(--white);
				box-shadow: 0px 0px 9px 3px rgba(0, 0, 0, 0.1);
				margin: 5px;
				border-radius: 8px;
				border-bottom-right-radius: 0px;
				background-image: url(${require("@/assets/img/labyes.png")
					.default});
				background-repeat: no-repeat;
				background-position: right bottom;
				position: relative;

				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 1em;
				padding-bottom: 5em;

				.close {
					cursor: pointer;
					position: absolute;
					top: 1em;
					right: 1em;
				}

				.form {
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 65%;

					input {
						width: 100%;
						max-width: 100%;
						height: 40px;
						border: 0;
						border-bottom: 1px solid #333;
						text-align: center;
						margin-bottom: 1.5em;
					}

					button {
						min-width: 218px;
						width: 100%;
						max-width: 218px;
						text-transform: inherit;
						font-weight: bold;
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		/* background-image: url(${require("@/assets/img/labyes.png")
			.default});
		background-repeat: no-repeat;
		background-position: right bottom; */

		h2 {
			text-transform: uppercase;
		}

		.cupons {
			flex-direction: row;
			flex-wrap: wrap;
			padding-bottom: 3em;
			max-height: 75vh;
			overflow-y: auto;

			li {
				min-width: 345px;
				max-width: 345px;
				margin-right: 3em;

				p {
					font-size: 1em;
				}
			}
		}

		.modal {
			background-color: rgba(0, 0, 0, 0.9);
			.content {
				position: relative;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
`;
